/**
 * Override Insider Smart Recommender description copy for one product.
 * Set productTitle and productDescription below to enable; leave blank to disable.
 */
(function () {
  var productTitle = "Air Dry Styling Cream";
  var productDescription =
    "This lightweight, flexible styling gel cream enhances texture with soft hold, smoothing the cuticle and reducing frizz for a polished, blowout-like finish.";

  function normalizeTitle(value) {
    return (value || "").replace(/\s+/g, " ").trim().toLowerCase();
  }

  function getConfig() {
    if (!productTitle || !productDescription) return null;

    return {
      productTitle: normalizeTitle(productTitle),
      productDescription: String(productDescription).trim(),
    };
  }

  function updateDescriptionAccessibility(descriptionLink, description) {
    descriptionLink.setAttribute("aria-label", description);

    var status = descriptionLink.closest('[role="status"]');
    if (!status) return;

    var box = descriptionLink.closest(".ins-web-smart-recommender-box-item");
    var titleLink = box
      ? box.querySelector(".ins-product-box-link.ins-dynamic-text-product-link")
      : null;
    var title = titleLink ? titleLink.textContent.trim() : "";

    status.setAttribute(
      "aria-label",
      title ? title + ". " + description : description,
    );
  }

  function applyOverride(root) {
    var config = getConfig();
    if (!config) return;

    var scope = root && root.querySelectorAll ? root : document;
    scope
      .querySelectorAll(".ins-web-smart-recommender-box-item")
      .forEach(function (box) {
        var titleLink = box.querySelector(
          ".ins-product-box-link.ins-dynamic-text-product-link",
        );
        var descriptionLink = box.querySelector(
          ".ins-sample-element-children.ins-dynamic-text-product-link",
        );

        if (!titleLink || !descriptionLink) return;
        if (normalizeTitle(titleLink.textContent) !== config.productTitle)
          return;
        if (descriptionLink.textContent.trim() === config.productDescription)
          return;

        descriptionLink.textContent = config.productDescription;
        updateDescriptionAccessibility(
          descriptionLink,
          config.productDescription,
        );
      });
  }

  function isInsiderNode(node) {
    if (!node || node.nodeType !== 1 || !node.matches) return false;

    return (
      node.matches(
        ".ins-web-smart-recommender, .ins-web-smart-recommender-box-item, .ins-dynamic-text-product-link",
      ) || !!node.querySelector(".ins-web-smart-recommender-box-item")
    );
  }

  function startObserver() {
    if (!window.MutationObserver) return;

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        for (var j = 0; j < mutation.addedNodes.length; j++) {
          var node = mutation.addedNodes[j];
          if (isInsiderNode(node)) applyOverride(node);
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    if (!getConfig()) return;

    applyOverride();
    startObserver();
    window.addEventListener("load", applyOverride);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
